export default "__VITE_ASSET__Dids0pnO__"